import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "o-homeEstimateSlider" }
const _hoisted_2 = { class: "o-homeEstimateSlider__con" }
const _hoisted_3 = { class: "o-homeEstimateSlider__dial-borders" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "o-homeEstimateSlider__grad-left" }, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "o-homeEstimateSlider__grad-right" }, null, -1 /* HOISTED */)
const _hoisted_6 = { class: "o-homeEstimateSlider__dial-con__text-2" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { class: "o-homeEstimateSlider__dial-con__text-4" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "o-homeEstimateSlider__dial-con__text-6" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "o-homeEstimateSlider__dial-con__text-8" }
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { class: "o-homeEstimateSlider__dial-con__text-10" }
const _hoisted_15 = ["textContent"]
const _hoisted_16 = {
  width: "1633",
  height: "1633",
  viewBox: "0 0 1633 1633",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "o-homeEstimateSlider__dial"
}
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<g><circle cx=\"831.215\" cy=\"3.14816\" r=\"1\"></circle><circle cx=\"788.628\" cy=\"3.53627\" r=\"1\"></circle><circle cx=\"774.391\" cy=\"4.11805\" r=\"1\"></circle><circle cx=\"746.037\" cy=\"5.98255\" r=\"1\"></circle><circle cx=\"731.902\" cy=\"7.32993\" r=\"1\"></circle><circle cx=\"717.736\" cy=\"8.89521\" r=\"1\"></circle><circle cx=\"689.595\" cy=\"12.8552\" r=\"1\"></circle><circle cx=\"675.588\" cy=\"15.1908\" r=\"1\"></circle><circle cx=\"661.561\" cy=\"17.7121\" r=\"1\"></circle><circle cx=\"619.890\" cy=\"26.8968\" r=\"1\"></circle><circle cx=\"606.147\" cy=\"30.4719\" r=\"1\"></circle><circle cx=\"578.805\" cy=\"38.2255\" r=\"1\"></circle><circle cx=\"565.217\" cy=\"42.4864\" r=\"1\"></circle><circle cx=\"551.718\" cy=\"47.0062\" r=\"1\"></circle><circle cx=\"524.989\" cy=\"56.7246\" r=\"1\"></circle><circle cx=\"511.755\" cy=\"61.9303\" r=\"1\"></circle><circle cx=\"498.612\" cy=\"67.3619\" r=\"1\"></circle><circle cx=\"485.572\" cy=\"73.0377\" r=\"1\"></circle><circle cx=\"472.634\" cy=\"78.9303\" r=\"1\"></circle><circle cx=\"459.798\" cy=\"85.0510\" r=\"1\"></circle><circle cx=\"447.072\" cy=\"91.3991\" r=\"1\"></circle><circle cx=\"434.462\" cy=\"97.9733\" r=\"1\"></circle><circle cx=\"421.984\" cy=\"104.756\" r=\"1\"></circle><circle cx=\"409.595\" cy=\"111.764\" r=\"1\"></circle><circle cx=\"397.345\" cy=\"118.99\" r=\"1\"></circle><circle cx=\"385.216\" cy=\"126.414\" r=\"1\"></circle><circle cx=\"373.239\" cy=\"134.077\" r=\"1\"></circle><circle cx=\"361.388\" cy=\"141.901\" r=\"1\"></circle><circle cx=\"349.662\" cy=\"149.975\" r=\"1\"></circle><circle cx=\"338.086\" cy=\"158.231\" r=\"1\"></circle><circle cx=\"326.668\" cy=\"166.705\" r=\"1\"></circle><circle cx=\"315.384\" cy=\"175.353\" r=\"1\"></circle><circle cx=\"304.258\" cy=\"184.205\" r=\"1\"></circle><circle cx=\"293.284\" cy=\"193.245\" r=\"1\"></circle><circle cx=\"633.76\" cy=\"23.6122\" r=\"1\"></circle><circle cx=\"802.82\" cy=\"3.15439\" r=\"1\"></circle><circle cx=\"845.425\" cy=\"3.54259\" r=\"1\"></circle><circle cx=\"888.003\" cy=\"6.1467\" r=\"1\"></circle><circle cx=\"916.261\" cy=\"9.11112\" r=\"1\"></circle><circle cx=\"958.444\" cy=\"15.356\" r=\"1\"></circle><circle cx=\"972.43\" cy=\"17.9151\" r=\"1\"></circle><circle cx=\"1000.28\" cy=\"23.7975\" r=\"1\"></circle><circle cx=\"1014.08\" cy=\"27.1487\" r=\"1\"></circle><circle cx=\"1027.85\" cy=\"30.705\" r=\"1\"></circle><circle cx=\"1055.2\" cy=\"38.543\" r=\"1\"></circle><circle cx=\"1068.74\" cy=\"42.836\" r=\"1\"></circle><circle cx=\"1082.24\" cy=\"47.2909\" r=\"1\"></circle><circle cx=\"1108.94\" cy=\"57.0687\" r=\"1\"></circle><circle cx=\"1122.19\" cy=\"62.2888\" r=\"1\"></circle><circle cx=\"1135.3\" cy=\"67.7415\" r=\"1\"></circle><circle cx=\"1148.33\" cy=\"73.4358\" r=\"1\"></circle><circle cx=\"1161.26\" cy=\"79.3566\" r=\"1\"></circle><circle cx=\"1174.09\" cy=\"85.4767\" r=\"1\"></circle><circle cx=\"1186.8\" cy=\"91.8418\" r=\"1\"></circle><circle cx=\"1199.4\" cy=\"98.4335\" r=\"1\"></circle><circle cx=\"1211.88\" cy=\"105.243\" r=\"1\"></circle><circle cx=\"1224.24\" cy=\"112.268\" r=\"1\"></circle><circle cx=\"1236.48\" cy=\"119.491\" r=\"1\"></circle><circle cx=\"1248.59\" cy=\"126.94\" r=\"1\"></circle><circle cx=\"1260.57\" cy=\"134.592\" r=\"1\"></circle><circle cx=\"1272.41\" cy=\"142.446\" r=\"1\"></circle><circle cx=\"1284.11\" cy=\"150.521\" r=\"1\"></circle><circle cx=\"1295.67\" cy=\"158.793\" r=\"1\"></circle><circle cx=\"1307.07\" cy=\"167.254\" r=\"1\"></circle><circle cx=\"1318.34\" cy=\"175.924\" r=\"1\"></circle><circle cx=\"1329.46\" cy=\"184.776\" r=\"1\"></circle><circle cx=\"1340.41\" cy=\"193.837\" r=\"1\"></circle><circle cx=\"859.609\" cy=\"4.159\" r=\"1\"></circle><circle cx=\"901.38\" cy=\"7.35515\" r=\"1\"></circle><circle cx=\"944.429\" cy=\"12.9732\" r=\"1\"></circle></g>", 1)
const _hoisted_18 = {
  width: "0",
  height: "0",
  class: "o-homeEstimateSlider__clippath"
}
const _hoisted_19 = ["id"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("path", { d: "M0.499,0.745 C0.355,0.745,0.214,0.831,0.079,0.994 C0.044,1,0.009,0.909,0.001,0.709 C-0.006,0.51,0.016,0.313,0.052,0.27 C0.196,0.097,0.345,0.005,0.499,0.005 C0.653,0.005,0.803,0.098,0.948,0.274 C0.984,0.317,1,0.513,0.999,0.713 C0.991,0.913,0.956,1,0.921,0.997 C0.785,0.832,0.643,0.745,0.499,0.745" }, null, -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "o-homeEstimateSlider__handle-path__handle" }, null, -1 /* HOISTED */)
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_icon = _resolveComponent("a-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_icon, {
          class: "m-button__icon o-homeEstimateSlider__arrow",
          name: "arrow_down_indicator"
        }),
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", {
          class: _normalizeClass(`o-homeEstimateSlider__dial-con o-homeEstimateSlider__dial-con--active-${$data.activeDialItem}`),
          style: _normalizeStyle(`transform: translate(-50%, 8.25rem) rotate(${$data.dialRotation}deg);`)
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.changeSliderValue(10, true))),
              textContent: _toDisplayString($props.sliderLabels.sliderLabelMinus4)
            }, null, 8 /* PROPS */, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.changeSliderValue(30, true))),
              textContent: _toDisplayString($props.sliderLabels.sliderLabelMinus2)
            }, null, 8 /* PROPS */, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.changeSliderValue(50, true))),
              textContent: _toDisplayString($props.sliderLabels.sliderLabel0)
            }, null, 8 /* PROPS */, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.changeSliderValue(70, true))),
              textContent: _toDisplayString($props.sliderLabels.sliderLabelPlus2)
            }, null, 8 /* PROPS */, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.changeSliderValue(90, true))),
              textContent: _toDisplayString($props.sliderLabels.sliderLabelPlus4)
            }, null, 8 /* PROPS */, _hoisted_15)
          ]),
          (_openBlock(), _createElementBlock("svg", _hoisted_16, [
            _createElementVNode("g", null, [
              _createElementVNode("circle", {
                cx: "538.309",
                cy: "51.7439",
                r: "3",
                class: "o-homeEstimateSlider__dial-con__circle-1",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.changeSliderValue(0, true)))
              }),
              _createElementVNode("circle", {
                cx: "592.4",
                cy: "34.1813",
                r: "3",
                class: "o-homeEstimateSlider__dial-con__circle-2",
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.changeSliderValue(10, true)))
              }),
              _createElementVNode("circle", {
                cx: "647.605",
                cy: "20.5268",
                r: "3",
                class: "o-homeEstimateSlider__dial-con__circle-3",
                onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.changeSliderValue(20, true)))
              }),
              _createElementVNode("circle", {
                cx: "703.629",
                cy: "10.7934",
                r: "3",
                class: "o-homeEstimateSlider__dial-con__circle-4",
                onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.changeSliderValue(30, true)))
              }),
              _createElementVNode("circle", {
                cx: "760.384",
                cy: "4.93039",
                r: "3",
                class: "o-homeEstimateSlider__dial-con__circle-5",
                onClick: _cache[9] || (_cache[9] = ($event: any) => ($options.changeSliderValue(40, true)))
              }),
              _createElementVNode("circle", {
                cx: "817",
                cy: "3.0011",
                r: "3",
                class: "o-homeEstimateSlider__dial-con__circle-6",
                onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.changeSliderValue(50, true)))
              }),
              _createElementVNode("circle", {
                cx: "873.817",
                cy: "5.00775",
                r: "3",
                class: "o-homeEstimateSlider__dial-con__circle-7",
                onClick: _cache[11] || (_cache[11] = ($event: any) => ($options.changeSliderValue(60, true)))
              }),
              _createElementVNode("circle", {
                cx: "930.36",
                cy: "10.9291",
                r: "3",
                class: "o-homeEstimateSlider__dial-con__circle-8",
                onClick: _cache[12] || (_cache[12] = ($event: any) => ($options.changeSliderValue(70, true)))
              }),
              _createElementVNode("circle", {
                cx: "986.51",
                cy: "20.7861",
                r: "3",
                class: "o-homeEstimateSlider__dial-con__circle-9",
                onClick: _cache[13] || (_cache[13] = ($event: any) => ($options.changeSliderValue(80, true)))
              }),
              _createElementVNode("circle", {
                cx: "1041.55",
                cy: "34.4491",
                r: "3",
                class: "o-homeEstimateSlider__dial-con__circle-10",
                onClick: _cache[14] || (_cache[14] = ($event: any) => ($options.changeSliderValue(90, true)))
              }),
              _createElementVNode("circle", {
                cx: "1095.64",
                cy: "52.0575",
                r: "3",
                class: "o-homeEstimateSlider__dial-con__circle-11",
                onClick: _cache[15] || (_cache[15] = ($event: any) => ($options.changeSliderValue(100, true)))
              })
            ]),
            _hoisted_17
          ]))
        ], 6 /* CLASS, STYLE */)
      ]),
      _createElementVNode("div", {
        class: "o-homeEstimateSlider__slider-borders",
        style: _normalizeStyle({
                    '--top': `${Math.abs($data.handleRotation) / 2.2}%`,
                    '--slider-dot-rotation': `${$data.handleRotation}%`,
                    '--slider-dot-rotation-abs': `${Math.abs($data.handleRotation)}%`,
                })
      }, [
        _createElementVNode("div", {
          class: "o-homeEstimateSlider__bg",
          style: _normalizeStyle(`clip-path: url('#${_ctx.$props.sliderInstance}');`)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["o-homeEstimateSlider__bg__remaining", `${$data.dialAnimation ? 'has-animation' : ''}`]),
            style: _normalizeStyle({ width: $data.remaining + '%' })
          }, null, 6 /* CLASS, STYLE */)
        ], 4 /* STYLE */),
        (_openBlock(), _createElementBlock("svg", _hoisted_18, [
          _createElementVNode("defs", null, [
            _createElementVNode("clipPath", {
              id: _ctx.$props.sliderInstance,
              clipPathUnits: "objectBoundingBox"
            }, _hoisted_21, 8 /* PROPS */, _hoisted_19)
          ])
        ])),
        _withDirectives(_createElementVNode("input", {
          ref: "slider",
          type: "range",
          min: "0",
          max: "100",
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($data.sliderValue) = $event)),
          onInput: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => ($options.onRangeInput && $options.onRangeInput(...args))),
          onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => ($options.onRangeChange && $options.onRangeChange(...args))),
          onKeyup: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => ($options.setHandleOnKeys && $options.setHandleOnKeys(...args)))
        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vModelText, $data.sliderValue]
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["o-homeEstimateSlider__handle-path", `${$data.dialAnimation ? 'has-animation' : ''}`]),
          style: _normalizeStyle(`transform: translate(-50%, -6.25rem) rotate(${$data.handleRotation}deg);`)
        }, _hoisted_23, 6 /* CLASS, STYLE */)
      ], 4 /* STYLE */)
    ])
  ]))
}